"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardSerializer = void 0;
var standards_1 = require("../../models/standards");
/**
 * Serializes CCSS Standard Tags
 *
 * @author braulio.castro
 */
var StandardSerializer = /** @class */ (function () {
    function StandardSerializer() {
    }
    StandardSerializer.prototype.serializeItemStandard = function (_a) {
        var externalItemId = _a.externalItemId, standardSetGlobalId = _a.standardSetGlobalId, standardSetId = _a.standardSetId, standardGlobalIds = _a.standardGlobalIds, standardId = _a.standardId, hierarchyLevel = _a.hierarchyLevel;
        return new standards_1.ItemStandard({
            externalItemId: externalItemId,
            standardGlobalIds: standardGlobalIds,
            standardId: standardId,
            standardSetGlobalId: standardSetGlobalId,
            standardSetId: standardSetId,
            hierarchyLevel: hierarchyLevel,
        });
    };
    StandardSerializer.prototype.serializeAssessmentTemplateItemStandard = function (_a) {
        var assessmentTemplateId = _a.assessmentTemplateId, itemStandards = _a.itemStandards;
        return new standards_1.AssessmentTemplateItemStandard({
            assessmentTemplateId: assessmentTemplateId,
            itemStandards: (itemStandards || []).map(function (itemStandard) {
                return new standards_1.ItemStandard({
                    externalItemId: itemStandard.externalItemId,
                    standardGlobalIds: itemStandard.standardGlobalIds,
                    standardId: itemStandard.standardId,
                    standardSetGlobalId: itemStandard.standardSetGlobalId,
                    standardSetId: itemStandard.standardSetId,
                    hierarchyLevel: itemStandard.hierarchyLevel,
                });
            }),
        });
    };
    return StandardSerializer;
}());
exports.StandardSerializer = StandardSerializer;
